import * as React from 'react';
import Loadable from 'react-loadable';
import { Route } from 'react-router-dom';
import { Switch, Redirect, withRouter } from 'react-router';
import { connect } from 'react-redux';
import type { RoutesProps, ProtectedRouteProps } from './Router.types';
import ProtectedRoute from './ProtectedRoute';
import AcceptTermsComponent from '../components/AcceptTerms';
import { Loader } from '../components/ui';

const ProtectedRouteHOC = LoadableComponent => (props: ProtectedRouteProps) => (
  <ProtectedRoute {...props}>
    <LoadableComponent {...props} />
  </ProtectedRoute>
);

// ON Start up read:
// const token = localStorage.getItem('ocot_access_token');
// and validate token, if valid, dispatch action to Log In.
const Routes = ({ isLoggedIn, isPasswordSecure, isAdmin, impersonating, user: { acceptedTerms }, hasAutomatedPayments}: RoutesProps) => (
  <React.Fragment>
    {isLoggedIn && !acceptedTerms && !impersonating && <AcceptTermsComponent />}
    <Switch>
      <Redirect exact from="/" to="/login" />

      <Route
        exact
        path="/login"
        component={Loadable({
          loader: () => import('../screens/Auth/Login'),
          loading: () => <Loader cover />
        })}
      />

      <Route
        exact
        path="/recuperar-contraseña"
        component={Loadable({
          loader: () => import('../screens/ResetPassword'),
          loading: () => <Loader cover />
        })}
      />

      {/* PRIVATE ROUTES START */}

      <Route
        exact
        path="/ordenes"
        component={
          isLoggedIn && isPasswordSecure
            ? ProtectedRouteHOC(
                Loadable({
                  loader: () => import('../screens/OrdersUser'),
                  loading: () => <Loader cover />
                })
              )
            : () => <Redirect to={!isPasswordSecure ? '/cambio-contraseña' : '/login'} />
        }
      />

      <Route
        exact
        path="/estado-cuenta"
        component={
          isLoggedIn && isPasswordSecure
            ? ProtectedRouteHOC(
                Loadable({
                  loader: () => import('../screens/AssociatedInvoices'),
                  loading: () => <Loader cover />
                })
              )
            : () => <Redirect to={!isPasswordSecure ? '/cambio-contraseña' : '/login'} />
        }
      />

      <Route
        exact
        path="/importar"
        component={
          isLoggedIn && isPasswordSecure && hasAutomatedPayments
            ? ProtectedRouteHOC(
                Loadable({
                  loader: () => import('../screens/ImportExcel'),
                  loading: () => <Loader cover />
                })
              )
            : () => <Redirect to={!isPasswordSecure ? '/cambio-contraseña' : '/login'} />
        }
      />

      {/* <Route
        exact
        path="/estadoCuenta"
        component={
          isLoggedIn && isPasswordSecure
            ? ProtectedRouteHOC(
              Loadable({
                loader: () => import('../screens/AccountStatement'),
                loading: () => <Loader cover />
              })
            )
            : () => <Redirect to={!isPasswordSecure ? '/cambio-contraseña' : '/login'} />}
      /> */}

      <Route
        exact
        path="/admin/ordenes"
        component={
          isLoggedIn && isPasswordSecure && isAdmin
            ? ProtectedRouteHOC(
                Loadable({
                  loader: () => import('../screens/OrdersAdmin'),
                  loading: () => <Loader cover />
                })
              )
            : () => <Redirect to={!isPasswordSecure ? '/admin/cambio-contraseña' : '/login'} />
        }
      />

      <Route
        exact
        path="/admin/pagos"
        component={
          isLoggedIn && isPasswordSecure && isAdmin
            ? ProtectedRouteHOC(
                Loadable({
                  loader: () => import('../screens/PaymentsAdmin'),
                  loading: () => <Loader cover />
                })
              )
            : () => <Redirect to={!isPasswordSecure ? '/admin/cambio-contraseña' : '/login'} />
        }
      />
      <Route
        exact
        path="/admin/impersonate"
        component={
          isLoggedIn && isPasswordSecure && isAdmin
            ? ProtectedRouteHOC(
                Loadable({
                  loader: () => import('../screens/ImpersonateProvider'),
                  loading: () => <Loader cover />
                })
              )
            : () => <Redirect to={!isPasswordSecure ? '/admin/cambio-contraseña' : '/login'} />
        }
      />
      <Route
        exact
        path="/admin/orden/:id/tipo/:type"
        component={
          isLoggedIn && isPasswordSecure && isAdmin
            ? ProtectedRouteHOC(
                Loadable({
                  loader: () => import('../screens/OrderItemAdmin'),
                  loading: () => <Loader cover />
                })
              )
            : () => <Redirect to={!isPasswordSecure ? '/admin/cambio-contraseña' : '/login'} />
        }
      />
      <Route
        exact
        path="/admin/cambio-contraseña"
        component={
          isLoggedIn && isAdmin
            ? ProtectedRouteHOC(
                Loadable({
                  loader: () => import('../screens/ChangePassword'),
                  loading: () => <Loader cover />
                })
              )
            : () => <Redirect to="/login" />
        }
      />

      <Route
        exact
        path="/orden/:id/tipo/:type"
        component={
          isLoggedIn && isPasswordSecure
            ? ProtectedRouteHOC(
                Loadable({
                  loader: () => import('../screens/OrderItem'),
                  loading: () => <Loader cover />
                })
              )
            : () => <Redirect to={!isPasswordSecure ? '/cambio-contraseña' : '/login'} />
        }
      />

      <Route
        exact
        path="/cambio-contraseña"
        component={
          isLoggedIn
            ? ProtectedRouteHOC(
                Loadable({
                  loader: () => import('../screens/ChangePassword'),
                  loading: () => <Loader cover />
                })
              )
            : () => <Redirect to="/login" />
        }
      />

      {/* <Route
        exact
        path="/payments/:id"
        component={
          isLoggedIn
            ? ProtectedRouteHOC(
              Loadable({
                loader: () => import('../screens/InsurancePayments'),
                loading: () => <Loader cover />
              })
            )
            : () => <Redirect to="/login" />}
      /> */}
    </Switch>
  </React.Fragment>
);

const mapStateToProps = state => ({
  isLoggedIn: state.auth.isLoggedIn,
  isPasswordSecure: state.auth.isPasswordSecure,
  isAdmin: state.auth.user?.isAdmin,
  user: state.auth.user || { acceptedTerms: false },
  impersonating: state.auth.impersonating || false,
  hasAutomatedPayments: state.auth.user?.providerCode === 1185
});

export default withRouter(connect(mapStateToProps)(Routes));
